import { makeAssetReducer } from './reducer-helpers';
import { LIST_ALL_ASSETS } from '../bridge-method-remap';
export default makeAssetReducer(LIST_ALL_ASSETS);
